import { DmsSyncQueueLogRequestModel, FeatureModel } from './../../business-entities/dms-sync-queue-log-request-model';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { DMSQueueLogList } from '../../business-entities/dmsqueue-log-list';
import { DMSSyncFailedlogService } from '../../business-services/dms-sync-failed-log.service';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { DmsQueueexceptionComponent } from '../dms-queueexception/dms-queueexception.component';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { DatePipe } from '@angular/common';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { AdminCommonService } from '../../services/admin-common.service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-dms-syncschedulerlog',
  templateUrl: './dms-syncschedulerlog.component.html',
})
export class DmsSyncschedulerlogComponent implements OnInit {
  paginationSub: Subscription;
  total$: number = 0;
  totalCount: number = 0;
  dMSQueueLogList: DMSQueueLogList[] = [];
  popupCloseResult = false;
  rowId: number;
  featureList: FeatureModel[];
  integrationWithDMS: boolean = false;
  bookingDate: any[] = [];
  todayViewDate: any;
  weekViewDate: any;
  isTodayViewOn: boolean = true;
  isWeekViewOn: boolean = false;
  throttle = 100;
  scrollDistance = 1;
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });

  dmsSyncQueueLogRequestModel: DmsSyncQueueLogRequestModel =
    {
      logType: '',
      logToDate: '',
      logDate: '',
      cultureCode: '',
      logFromDate: '',
      startRecordNumber: 0,
      pageSize: 25,
      sortColumn: '',
      sortDirection: ''
    };
    userRoleRightsDetails: UserRoleMenu;

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    public service: DMSSyncFailedlogService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    public pService: CustomPaggerService,
    private userService: UserDataService,
    private adminCommonSer: AdminCommonService,

  ) {
    this.pService.pageSize = 10;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.dmsSyncQueueLogRequestModel.sortDirection = direction;
    this.dmsSyncQueueLogRequestModel.sortColumn = column;
    this.dmsSyncQueueLogRequestModel.startRecordNumber = 0;
    this.dMSQueueLogList = [];
    this.GetDMSQueueLogList(this.dmsSyncQueueLogRequestModel);
  }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.DMSSyncSchedulerlog);
    if (this.service.filterTypeId == 1) {
      this.loadTodayView();
    } else if (this.service.filterTypeId == 2) {
      this.loadWeekView();
    } else {
      this.loadTodayView();
    }
  }

  loadTodayView() {
    this.isTodayViewOn = true;
    this.isWeekViewOn = false;
    let todays_date = new Date();

    this.weekViewDate = this.datePipe.transform(todays_date, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(todays_date, 'dd/MM/yyyy');
    this.bookingDate=[];
    this.bookingDate.push(todays_date);
    this.bookingDate.push(todays_date);
    this.todayViewDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    this.dmsSyncQueueLogRequestModel.logToDate = this.todayViewDate;
    this.dmsSyncQueueLogRequestModel.startRecordNumber = 0;
    this.dMSQueueLogList = [];
    this.GetDMSQueueLogList(this.dmsSyncQueueLogRequestModel);
  }
  loadWeekView() {
    this.isTodayViewOn = false;
    this.isWeekViewOn = true;
    const  { weekViewDate, bookingDate } =this.adminCommonSer.getWeekViewDatesNew(1);
    this.bookingDate = [...bookingDate];
    this.dmsSyncQueueLogRequestModel.logToDate =weekViewDate;
    this.dMSQueueLogList = [];
    this.GetDMSQueueLogList(this.dmsSyncQueueLogRequestModel);
  }
  onDateRangeChanged(event: any) {
    this.bookingDate = (typeof event === 'undefined') ? [] : event;
    this.dmsSyncQueueLogRequestModel.startRecordNumber = 0;
    this.dMSQueueLogList = [];
    this.GetDMSQueueLogList(this.dmsSyncQueueLogRequestModel);
  }
  onClickChangeView(isWeek: boolean) {
    if (isWeek) {
      this.loadWeekView()
    } else {
      this.loadTodayView()
    }
  }
  refresh() {
    this.dmsSyncQueueLogRequestModel.startRecordNumber = 0;
    this.dMSQueueLogList = [];
    this.GetDMSQueueLogList(this.dmsSyncQueueLogRequestModel);
  }

  monthDiff(d1: any, d2: any) {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();
    // edit: increment months if d2 comes later in its month than d1 in its month
    if (d2.getDate() >= d1.getDate())
      months++
    // end edit
    return months <= 0 ? 0 : months;
  }


  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }


  onDelete(rowId: number, deletefrom: string) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblqueues"), false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.service.DeleteQueue(rowId, deletefrom).then((response) => {
          if (response.responseCode === Constant.SuccessResponseCode) {
            let successMsg = this.translate.instant('lbllogDataDeleteSuccess')
            this.toastr.success(successMsg);
            this.dMSQueueLogList = [];
            this.GetDMSQueueLogList(this.dmsSyncQueueLogRequestModel);

          }
        });
      }
    })

  }

  switchTabs(flag: string) {
    if (flag == "HistoryTab"){
      this.dmsSyncQueueLogRequestModel.startRecordNumber = 0;
      this.dmsSyncQueueLogRequestModel.logType = 'History';
    }
    else{
      this.dmsSyncQueueLogRequestModel.startRecordNumber = 0;
      this.dmsSyncQueueLogRequestModel.logType = 'Queue';
    }
    this.GetDMSQueueLogList(this.dmsSyncQueueLogRequestModel);
    this.dMSQueueLogList = [];
  }

  GetDMSQueueLogList(_DmsSyncQueueLogRequestModel: DmsSyncQueueLogRequestModel) {
      let bookingDateFormatted= this.getFormattedDate(this.bookingDate);
      let startDate = new Date(this.datePipe.transform(this.bookingDate[0], 'MM/dd/yyyy'));
      let endDate = new Date(this.datePipe.transform(this.bookingDate[1], 'MM/dd/yyyy'));
      if (this.monthDiff(startDate, endDate) >= 3) {
        let addedMsg = this.translate.instant('lbldaterangeForThreeMonths');
        this.toastr.warning(addedMsg);
        return;
      }
      if (bookingDateFormatted === '') {
        this.dmsSyncQueueLogRequestModel.logFromDate = bookingDateFormatted;
        this.dmsSyncQueueLogRequestModel.logToDate = bookingDateFormatted;
      }
      else{
        this.dmsSyncQueueLogRequestModel.logFromDate = this.datePipe.transform(startDate, 'dd/MM/yyyy');
        this.dmsSyncQueueLogRequestModel.logToDate = this.datePipe.transform(endDate, 'dd/MM/yyyy');
      }

    this.spinner.show();

    this.service.GetDmsSyncQueueLog(this.dmsSyncQueueLogRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        let data = response.responseObject;
        if(data?.length>0){
          data.forEach(element => {
            this.convertUTCDateToLocal(element, 'createdDate');
            this.convertUTCDateToLocal(element, 'processDate');
          });
        }
        this.dMSQueueLogList.push(...data);
        this.totalCount = this.dMSQueueLogList.length > 0 ? this.dMSQueueLogList[0].totalCount : 0;
      }

      else if (response.responseObject && response.responseObject.errorCount > 0 &&
        response.responseObject.result && response.responseObject.result.errorCode === Enums.ErrorCodes.log) {
        this.spinner.hide();
      }
      this.spinner.hide();

     });

    }
    
convertUTCDateToLocal(element, dateField) {
  if (element[dateField]) {
    element[dateField] = Utility.ConvertUTCDateToLocalDate(new Date(element[dateField] + "Z"));
  }
}
  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.service.filterTypeId = 0;
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }

  viewException(result) {
    let modelHeadermsg = "";
    if (result.syncStatus == 1) {
      modelHeadermsg = this.translate.instant("lblSyncLog");
      result.responseStatusCode = "Success";
    }
    else {
      modelHeadermsg = this.translate.instant("lblSyncErrorLog");
      result.responseStatusCode = "Error";
    }
    const modalRef = this.modalService.open(DmsQueueexceptionComponent, { size: 'lg' });
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.dMSQueueLogList = result;
    modalRef.componentInstance.integrationWithDMS = this.integrationWithDMS;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);

    });
  }
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }
    return rtPageNumber;
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.dMSQueueLogList.length) {
      this.dmsSyncQueueLogRequestModel.startRecordNumber = this.dMSQueueLogList.length
      this.GetDMSQueueLogList(this.dmsSyncQueueLogRequestModel);
    }
  }

  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}

